









import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import PriceConfigItem from '@/dto/price_config/PriceConfigItem'

@Component
export default class PriceConfigItemsHeader extends Vue {
  @Prop(Object)
  model: PriceConfigItem
}
